export const isValidUrl = (url: string) => {
  const pattern = new RegExp(
    '^(https?:\\/\\/)?' + //* HTTP 또는 HTTPS로 시작할 수 있습니다.
      '((([a-zA-Z\\d]([a-zA-Z\\d-]*[a-zA-Z\\d])*)\\.)+[a-zA-Z]{2,}|' + //* 도메인 이름
      '((\\d{1,3}\\.){3}\\d{1,3}))' + //* 또는 IPv4 주소
      '(\\:\\d+)?(\\/[-a-zA-Z\\d%_.~+]*)*' + //* 선택적 포트와 경로
      '(\\?[;&a-zA-Z\\d%_.~+=-]*)?' + //* 선택적 쿼리 스트링
      '(\\#[-a-zA-Z\\d_]*)?$', //* 선택적 프래그먼트
    'i',
  );

  return pattern.test(url);
};
